import { AfterViewInit, Component } from "@angular/core";
import { IonApp, IonRouterOutlet } from "@ionic/angular/standalone";
import { SplashScreen } from "@capacitor/splash-screen";
import { addIcons } from "ionicons";
import { addOutline, businessOutline, documentOutline, trash, chevronForward } from "ionicons/icons";
import { Toast } from "primeng/toast";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [IonApp, IonRouterOutlet, Toast],
  templateUrl: "./app.html",
  styleUrl: "./app.scss",
})
export class App implements AfterViewInit {
  constructor() {
    addIcons({ businessOutline, documentOutline, addOutline, trash, chevronForward });
  }

  ngAfterViewInit(): void {
    // Wait two animation frames to ensure initial rendering/paint is complete,
    // then hide the splash screen.
    requestAnimationFrame(() =>
      requestAnimationFrame(() => SplashScreen.hide()),
    );
  }
}
